import { render, staticRenderFns } from "./PhysicianMetrics.vue?vue&type=template&id=1fd1db53"
import script from "./PhysicianMetrics.vue?vue&type=script&lang=js"
export * from "./PhysicianMetrics.vue?vue&type=script&lang=js"
import style0 from "./PhysicianMetrics.vue?vue&type=style&index=0&id=1fd1db53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports